import React, { useEffect } from 'react';
import BrandMain from '../../components/brand/BrandMain';
import BrandSynergy from '../../components/brand/BrandSynergy';
import BrandGlobal from '../../components/brand/BrandGlobal';
import BrandOffline from '../../components/brand/BrandOffline';
import BrandInquiry from '../../components/brand/BrandInquiry';
import BrandBrands from '../../components/brand/BrandBrands';

const BrandPage = () => {
    useEffect(() => {
        document.title = '폰피쉬 브랜드 제휴 | 입점 문의';
    }, []);

    return (
        <div className="w-full pt-[60px] md:pt-[80px] md:pt-0">
            <BrandMain />
            <BrandSynergy />
            <BrandGlobal />
            <BrandOffline />
            <BrandInquiry />
            <BrandBrands />
        </div>
    );
};

export default BrandPage; 